<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Import Data
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Import File Peserta</label>
          <b-form-file
            v-model="fileUpload"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
          ></b-form-file>
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2 mt-2"
        >
        <div class="d-flex">
          <b-button variant="primary" @click="upload()">Submit</b-button>
          <b-button class="ml-1" variant="primary" @click="downloadTemplate()">Download Template</b-button>
        </div>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BFormInput,BButton,BFormFile,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {
  downloadTemplateSoal,
  uploadFileImportSoal,
} from '@/connection-api/master'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    BFormInput,
    BButton,
    BFormFile,
  },
  data() {
    return {
      filter: {},
      count: 0,
      fileUpload: null,
    }
  },
  methods: {
    async downloadTemplate(){
      const result = await downloadTemplateSoal();
      const blob = new Blob([result.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }); // XLSX MIME type
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      const date = new Date().toLocaleString(['ban', 'id']);
      const filename = `template-${date}.xlsx`.replace(/[^a-z0-9_.-]/gi, '_'); // replaces invalid characters
      link.download = filename;
      link.href = url;

      document.body.appendChild(link);
      link.click();

      // Clean up
      link.remove();
      window.URL.revokeObjectURL(url)
    },
    upload(){
        if(this.fileUpload != null)
        {
          uploadFileImportSoal(this.fileUpload, 'user', event => {
          var progress = Math.round((100 * event.loaded) / event.total)
        })
          .then(response => {
            this.$emit('refetchData')
          })
        .catch(error => console.log(error));
      }
    },
    cari()
    {
      this.count += 1
      this.$emit('update:dataFilter', this.filter)
      this.$emit('update:triggerFilter', this.count)
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
